import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Input, Select, DatePicker } from 'antd';
import api from '../services/api';
import dayjs from 'dayjs';

const { Option } = Select;

// Identificacao comum a todos os laudos de inspecao. Um arquivo so: mudou um
// campo aqui, muda em todos os laudos.
//
// Endereco de atendimento: enquanto o laudo e rascunho ele e relido da OS, de
// modo que mexer na proposta reflete no laudo. Quando o laudo vira documento
// — codigo reservado ou status concluido — o valor congela. Laudo assinado e
// entregue nao pode mudar sozinho; para isso existe revisao.
export default function CabecalhoLaudo({ d, set, tipoLaudo, congeladoForcado, semArt }) {
  const [cnpjs, setCnpjs] = useState([]);

  useEffect(() => {
    api.get('/clientes/cnpjs/todos').then((r) => setCnpjs(r.data || [])).catch(() => {});
  }, []);

  const congelado = congeladoForcado !== undefined
    ? congeladoForcado
    : !!(d.codigo || d.status === 'concluido');

  useEffect(() => {
    if (!d.numero_os) return; // no ERP nada trava: endereco acompanha a OS
    let vivo = true;
    api.get('/os/buscar?numero=' + encodeURIComponent(d.numero_os))
      .then((r) => {
        const os = r.data;
        if (!vivo || !os) return;
        if (os.endereco_atendimento && os.endereco_atendimento !== d.endereco_atendimento) {
          set('endereco_atendimento', os.endereco_atendimento);
        }
        if (os.tecnico && !d.tecnico) set('tecnico', os.tecnico);
      })
      .catch(() => { /* laudo avulso, sem OS: segue com o que esta gravado */ });
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [d.numero_os, congelado]);

  // cnpjDaOSv2: com OS, o CNPJ do laudo e sempre o definido na OS
  useEffect(() => {
    if (!d.numero_os) return;
    let vivo = true;
    api.get('/os/buscar?numero=' + encodeURIComponent(d.numero_os))
      .then((r) => {
        const c = r.data && (r.data.cnpj_laudo_id || r.data.cnpj_faturamento_id);
        if (vivo && c && c !== d.cnpj_faturamento_id) set('cnpj_faturamento_id', c);
      })
      .catch(() => {});
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [d.numero_os, d.id]);

  const cnpjSel = cnpjs.find((c) => c.id === d.cnpj_faturamento_id);
  const art = cnpjSel ? (cnpjSel.art_numero || '') : (d.art_numero || '');

  return (
    <Card size="small" title="Identificação">
      <Row gutter={16}>
        <Col span={8}>
          <label>Cliente</label>
          <Input value={d.razao_social || d.nome_cliente || ''} disabled />
        </Col>
        <Col span={8}>
          <label>CNPJ do Laudo</label>
          <Select style={{ width: '100%' }} showSearch allowClear placeholder="Pesquise pelo CNPJ"
            optionFilterProp="children" value={d.cnpj_faturamento_id || undefined}
            disabled={!!(d.os_id || d.numero_os)}
            onChange={(v) => set('cnpj_faturamento_id', v || null)}>
            {cnpjs.map((c) => (
              <Option key={c.id} value={c.id}>
                {c.cnpj} — {c.razao_social} {c.cliente_nome ? '(' + c.cliente_nome + ')' : ''}
              </Option>
            ))}
          </Select>
          {(d.os_id || d.numero_os) ? <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 2 }}>Definido na OS — para trocar, edite a OS.</div> : null}
        </Col>
        {!semArt && (<Col span={8}>
          <label>ART do Cliente (CREA-MG)</label>
          <Input value={art} disabled
            style={{ background: '#f6ffed', color: '#135200', fontWeight: 'bold' }} />
        </Col>)}
      </Row>

      <Row gutter={16} style={{ marginTop: 12 }}>
        <Col span={8}>
          <label>Tipo de Laudo</label>
          <Input value={tipoLaudo || d.tipo_laudo || ''} disabled />
        </Col>
        <Col span={5}>
          <label>Número da OS</label>
          <Input value={d.numero_os || ''} disabled />
        </Col>
        <Col span={5}>
          <label>Data da inspeção *</label>
          <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY"
            value={d.data_inspecao ? dayjs(String(d.data_inspecao).substring(0, 10)) : null}
            onChange={(v) => set('data_inspecao', v ? v.format('YYYY-MM-DD') : null)} />
        </Col>
        <Col span={6}>
          <label>Técnico responsável</label>
          <Input value={d.tecnico || ''} disabled />
        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: 12 }}>
        <Col span={20}>
          <label>Endereço de Atendimento</label>
          <Input value={d.endereco_atendimento || ''} disabled />
        </Col>
        <Col span={4}>
          <label>Revisão</label>
          <Input value={d.revisao === null || d.revisao === undefined ? '00'
            : String(d.revisao).padStart(2, '0')} disabled />
        </Col>
      </Row>
    </Card>
  );
}
